// mds-dojo — dojo/window (window utilities, NOT dojo/_base/window). Faithful subset
// of references/dojo/window.js: getBox() (viewport dimensions + scroll), getScroll(),
// get() (the window for a doc), scrollIntoView(). The legacy IE/quirks branches are
// dropped (modern evergreen); getBox returns {w,h,l,t} exactly like dojo.
const doc0 = typeof document !== 'undefined' ? document : null;

export function get(doc: any): any {
  // Get window object associated with document doc.
  if (doc && doc.parentWindow) { return doc.parentWindow; }
  return (doc && doc.defaultView) || (typeof window !== 'undefined' ? window : null);
}

export function getScroll(doc?: any): any {
  doc = doc || doc0;
  const w = get(doc);
  const de = doc.documentElement;
  const x = (w && w.pageXOffset) || de.scrollLeft || (doc.body && doc.body.scrollLeft) || 0;
  const y = (w && w.pageYOffset) || de.scrollTop || (doc.body && doc.body.scrollTop) || 0;
  return { x: x, y: y };
}

export function getBox(doc?: any): any {
  // Return the dimensions and scroll position of the viewable area of a browser window.
  doc = doc || doc0;
  const de = doc.documentElement;
  const w = get(doc);
  // Modern standards mode: documentElement.clientWidth/Height is the viewport.
  const width = de.clientWidth || (w && w.innerWidth) || 0;
  const height = de.clientHeight || (w && w.innerHeight) || 0;
  const scroll = getScroll(doc);
  return { l: scroll.x, t: scroll.y, w: width, h: height };
}

export function scrollIntoView(node: any, pos?: any): void {
  // Scroll the passed node into view using minimal movement, if it is not already.
  try {
    if (node && node.scrollIntoView) { node.scrollIntoView(false); }
  } catch (e) { /* non-fatal */ }
}

const winUtils = { get, getScroll, getBox, scrollIntoView };
export default winUtils;
